﻿(function ($, document) {

    $(document).ready(function () {
        $('[data-alpha-list]').first().addClass('selected');
        $(document).on('click', '[data-alpha-index]', function (e) {
            e.preventDefault();

            $('[data-alpha-list].selected').removeClass('selected');
            $('[data-alpha-list="' + $(this).data('alpha-index') + '"]').addClass('selected');
        });
    });
})(jQuery, document);